export * from './timepicker.component';
export * from './timepicker.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/time-picker/index.ts